module.exports = __webpack_public_path__ + "img/grid-view-dark.9c697b29.svg";